module.exports = __webpack_public_path__ + "static/media/bg1.3926343f.jpg";